<template>
  <div class="home">

    <b-overlay :show="showOverlay" class="b-overlay-app" rounded="sm">
      <!--small v-if="isAdmin">Mode Administrateur</small-->
      <br>
      <nav class="nav-home">
        <router-link :to="{name: 'categories'}">
          <button class="btn btn-primary">
            <i class="fas fa-pencil-alt"></i>
            Saisir une sollicitation
          </button>
        </router-link>

        <router-link :to="{name: 'liste'}">
          <button class="btn btn-secondary">
            <i class="fas fa-eye"></i>
            Suivre mes sollicitations
          </button>
        </router-link>

        <router-link :to="{name: 'patrimoine'}">
          <button class="btn btn-secondary">
            <i class="fas fa-building"></i>
            Sollicitations de mon patrimoine
          </button>
        </router-link>

        <router-link :to="{name: 'relance'}">
          <button v-if="showRelance" class="btn btn-secondary">
            <i class="fas fa-sync-alt"></i>
            Sollicitations relancées
          </button>
        </router-link>

        <router-link :to="{name: 'all'}">
          <button v-if="showToute" class="btn btn-secondary">
            <i class="fas fa-user-tie"></i>
            Toutes les sollicitations
          </button>
        </router-link>
      </nav>

    </b-overlay>


  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "Home",
  computed: {
    ...mapGetters('entrees', ['allEntrees']),
    ...mapGetters('partenaires', ['partenaires']),
    ...mapGetters('user', ['getRoles', 'isAdmin', 'getCodeTiers']),
    showOverlay() {
      if (this.allEntrees && this.partenaires){
        this.loadEntreesFromPartnr(this.partenaires)
        return false
      }
      else
        return true
    },
    showRelance(){
      return this.getRoles.includes('ROLE_GESTIONNAIRE_RELANCE')
    },
    showToute(){
      return this.isAdmin;
    }
  },
  methods: {
    ...mapActions('title', ['setTitle']),
    ...mapActions('categories', ['loadCategoriesFromAPI']),
    ...mapActions('types', ['loadTypesFromAPI']),
    ...mapActions('natures', ['loadNaturesFromAPI']),
    ...mapActions('motifs', ['loadMotifsFromAPI']),
    ...mapActions('evenements', ['loadEvenementsFromAPI']),
    ...mapActions('actions', ['loadActionsFromAPI']),
    ...mapActions('entrees', ['loadEntreesFromPartnr', 'loadAllEntreesFromAPI']),
    ...mapActions('partenaires', ['loadPartenairesFromAPI']),
    ...mapActions('programmes', ['loadProgrammesFromAPI'])
  },
  mounted: function () {
    this.setTitle('')
    this.loadCategoriesFromAPI()
    this.loadTypesFromAPI()
    this.loadNaturesFromAPI()
    this.loadMotifsFromAPI()
    this.loadEvenementsFromAPI()
    this.loadActionsFromAPI()
    // Déjà chargées avec loadAllEntrees...
    //this.loadEntreesFromAPI(this.getCodeTiers)
    this.loadPartenairesFromAPI(this.getCodeTiers)
    //TODO MOCHE!!!
    this.loadAllEntreesFromAPI()
    this.loadProgrammesFromAPI()
  }
}
</script>

<style scoped>

.nav-home a {
  display: block;
  margin-bottom: 20px;
  padding: 0 20px;
}

.home {
  position: relative;
  display: block;
}


.nav-home a button {
  width: 100%;
  padding: 15px;
  font-size: 18px;
}

.nav-home a button i {
  margin-right: 10px;
}

</style>